module.exports = __webpack_public_path__ + "img/bb-logo-horz-clr.beef2f44.svg";